var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99414 13.0592L12.0371 17.1022L17.8951 8.90124L15.8601 7.44824L11.7181 13.2472L9.76114 11.2912L7.99414 13.0592Z",
    fill: "#00B574"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.87793 12.1738C2.87793 17.6878 7.36393 22.1738 12.8779 22.1738C18.3919 22.1738 22.8779 17.6878 22.8779 12.1738C22.8779 6.65983 18.3919 2.17383 12.8779 2.17383C7.36393 2.17383 2.87793 6.65983 2.87793 12.1738ZM4.87793 12.1738C4.87793 7.76283 8.46693 4.17383 12.8779 4.17383C17.2889 4.17383 20.8779 7.76283 20.8779 12.1738C20.8779 16.5848 17.2889 20.1738 12.8779 20.1738C8.46693 20.1738 4.87793 16.5848 4.87793 12.1738Z",
    fill: "#00B574"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "check-circle.410f149f851c1d0a0db68f9e8feab787.svg";